module.exports = __webpack_public_path__ + "644155cade2e46584bd1af26293a807a.svg";